
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

  const url = window.location.href;
  const userId = new URL(url.replace('#', '')).searchParams.get('userId');

    if (userId) {
      const cloned = req.clone({
        setHeaders: {
          "userId":userId
        }
      });

      return next.handle(cloned);
    }

    return next.handle(req);
  }
}
